var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M41.45 8.66a1.3 1.3 0 0 0-1.82.24L18.47 36.48 8.13 28.64a1.3 1.3 0 0 0-1.82.25 1.3 1.3 0 0 0 .25 1.82l11.37 8.62a1.3 1.3 0 0 0 1.81-.25l21.95-28.6a1.3 1.3 0 0 0-.24-1.83z",
  clipRule: "evenodd"
})));
export { SvgTick as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/tick.svg", import.meta.url).toString();